/* =========================================================================
   Global theme behaviour — mobile nav toggle.
   ========================================================================= */
(function () {
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest(".nav__toggle");
    if (!toggle) return;
    var nav = toggle.closest(".nav");
    var list = nav && nav.querySelector(".nav__links");
    if (!list) return;
    var open = list.classList.toggle("is-open");
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
  });
})();
